(function ($) {
    function submitPassword() {
        $("#passwordSecurityForm").on("submit", function(e) {
            e.preventDefault();
            $("#passwordSecurityButton").prop('disabled', true);

            var url = $(e.currentTarget).attr('action');
            var data = {
                newPassword: $("#passwordSecurityForm :input[name='passwordNew']").val(),
                oldPassword: $("#passwordSecurityForm :input[name='passwordOld']").val(),
                email: $("#passwordSecurityForm :input[name='email']").val()
            }
            
            $.ajax({
                   url: url, 
                   type: "POST",
                   data: JSON.stringify(data),
                   contentType: "application/json; charset=utf-8",
                   dataType: "json"
                })
                .done(function(doneResponse) {

                    if (doneResponse.responseCode === "SUCCESS") {
                        showNotification("success", doneResponse.message.mainMessage, doneResponse.message.helperMessage);

                        // Clear all panels
                        $('.component-account-edit-details').removeClass('active').css('display', 'none');
                        $('.infobody').addClass('active').removeClass('hideextra');
                        let passwordSectionLink = $('#link-passwordSecurityPanel');
                        if (passwordSectionLink.length > 0) {
                            passwordSectionLink.removeClass('active').find('span').text(passwordSectionLink.data('edit'));
                        }

                        // reset form
                        $("#passwordSecurityForm")[0].reset();
    
                        // reset new password validation
                        $("#passwordSecurityForm").find(".password-conditions .valid-number").removeClass("noPass").removeClass("pass");
                        $("#passwordSecurityForm").find(".password-conditions .valid-small-letter").removeClass("noPass").removeClass("pass");
                        $("#passwordSecurityForm").find(".password-conditions .valid-big-letter").removeClass("noPass").removeClass("pass");
                        $("#passwordSecurityForm").find(".password-conditions .valid-special-chars").removeClass("noPass").removeClass("pass");
                        $("#passwordSecurityButton").prop('disabled', true);
                    } else {
                        showNotification("error", doneResponse.message.mainMessage, doneResponse.message.helperMessage);
                    }
                    $("#passwordSecurityButton").prop('disabled', false);
                })
                .fail(function(failResponse) {
                    $("#passwordSecurityButton").prop('disabled', false);
                    showNotification("error", "Error", failResponse.message);
                    console.error(failResponse);
                });
        });
    }

    function validatePassword() {
      
      const formPasswordUpdate = "#passwordSecurityForm";
      var flagOldPassword, flagNewPassword, flagConfirmPassword;
  
      if($(formPasswordUpdate).length){
          $(".passwordEye").on("click", function(){
            if($(this).find(".fa-eye-slash").length){
                $(this).find(".fa").removeClass("fa-eye-slash").addClass("fa-eye");
                $(this).prev("input").attr("type","text");
            }
            else{
                $(this).find(".fa").removeClass("fa-eye").addClass("fa-eye-slash");
                $(this).prev("input").attr("type","password");
            }
          })
          $("#passwordOld").on("keyup change", function(){   
            if($(this).val() != ""){
                flagOldPassword = true;
            }else{
                flagOldPassword = false;
            }
            setSubmitBtn();
          })
        
        const lengthRegex = /.{8,}/;
        const lowercaseRegex = /.*[a-z].*/;
        const uppercaseRegex = /.*[A-Z].*/;
        const specialCharRegex = /.*[\W_].*/;
        var passwordElem, passwordVal;
        $("#passwordNew").on("keyup change", function(){   
            passwordElem = $(this);
            passwordVal = $(this).val();
            
            let validNumber = passwordElem.siblings(".sms-option").find(".password-conditions .valid-number");
            let validSmallLetter = passwordElem.siblings(".sms-option").find(".password-conditions .valid-small-letter");
            let validBigLetter = passwordElem.siblings(".sms-option").find(".password-conditions .valid-big-letter");
            let validSpecialChars = passwordElem.siblings(".sms-option").find(".password-conditions .valid-special-chars");
            if(passwordVal != ""){
                if(lengthRegex.test(passwordVal) == true && validNumber.length){
                    validNumber.removeClass("noPass").addClass("pass");
                    flagNewPassword = true;
                } else if (validNumber.length && validNumber != "") {
                    validNumber.removeClass("pass").addClass("noPass");
                    flagNewPassword = false;
                }
                if(lowercaseRegex.test(passwordVal) == true && validSmallLetter.length){
                    validSmallLetter.removeClass("noPass").addClass("pass");
                    flagNewPassword = true;
                } else if (validSmallLetter.length) {
                    validSmallLetter.removeClass("pass").addClass("noPass");
                    flagNewPassword = true;
                }
                if(uppercaseRegex.test(passwordVal) == true && validBigLetter.length){
                    validBigLetter.removeClass("noPass").addClass("pass");
                    flagNewPassword = true;
                } else if (validSmallLetter.length) {
                    validBigLetter.removeClass("pass").addClass("noPass");
                    flagNewPassword = false;
                }
                if(specialCharRegex.test(passwordVal) == true && validSpecialChars.length){
                    validSpecialChars.removeClass("noPass").addClass("pass");
                    flagNewPassword = true;
                } else if (validSmallLetter.length) {
                    validSpecialChars.removeClass("pass").addClass("noPass");
                    flagNewPassword = false;
                }
                if(flagNewPassword == true){
                    if($("#passwordConfirm").length != 0 && ($("#passwordConfirm").val() == $(this).val())){
                        flagConfirmPassword = true;
                    }else{
                        flagConfirmPassword = false;
                    }
                }
            }else{
                passwordElem.siblings(".sms-option").find(".password-conditions li").removeClass("pass").removeClass("noPass");
                flagNewPassword = false;
            }
            setSubmitBtn();
        })

        $("#passwordConfirm,#passwordNew").on("keyup change", function(){
            let passwordNew = $("#passwordNew");
            let passwordConfirm = $("#passwordConfirm");
            if(passwordNew.length != 0 && passwordConfirm.val() != ""){
                if(passwordNew.length != 0 && (passwordNew.val() == passwordConfirm.val())){
                    passwordConfirm.parent().removeClass("error");
                    passwordConfirm.siblings("#accountsecurityPassword-error").addClass("hidden");
                    flagConfirmPassword = true;
                }else{
                    passwordConfirm.parent().addClass("error");
                    passwordConfirm.siblings("#accountsecurityPassword-error").removeClass("hidden");
                    flagConfirmPassword = false;
                }
            } else
                flagConfirmPassword = false;
            setSubmitBtn();
        })
      }

      function setSubmitBtn(){
        if(flagOldPassword == true && flagNewPassword == true && flagConfirmPassword == true){
            $("#passwordSecurityButton").prop('disabled', false)
        }else{
            $("#passwordSecurityButton").prop('disabled', true);
        }
      }
    }
    
    const init = function () {
      validatePassword();
      submitPassword();
    };
  
    $(init);
  }(jQuery));
  